<div #stickyHeader class="CeActionTable-sticky-header" [attr.aria-hidden]="true">
    <ng-container *ngTemplateOutlet="headersTemplate"></ng-container>
</div>
<div class="CeActionTable-container" #container>
    <table>
        <!-- Headers -->
        <ng-container *ngTemplateOutlet="headersTemplate"></ng-container>
        <!-- Table rows -->
        @for (row of tableData?.rows; let i = $index; track i) {
            <tr
                class="CeActionTable-row"
                [ngClass]="{
                    'CeActionTable-row--selected': row.selected && tableData?.isSelectable,
                    'CeActionTable-row--disabled': row?.disabled,
                }"
            >
                <!-- Empty td for shadow-->
                @if (!firstColumnSticky()) {
                    <td class="shadow-indicator shadow-indicator--first" [attr.aria-hidden]="true"></td>
                }
                <!-- Expandable row -->
                @if (tableContainsSecondLevel) {
                    <td class="CeActionTable-row-item--empty">
                        @if (row.children) {
                            <!-- TODO: Use proper Ghost button [DSD-119] -->
                            <button
                                ce-button-small
                                ce-button-type-secondary
                                ce-button-ghost
                                (click)="row.collapsed = !row.collapsed"
                                [attr.aria-expanded]="!row.collapsed"
                            >
                                <ce-icon
                                    svgIcon="chevron-right-small"
                                    [@rotateChevron]="row.collapsed ? 'expanded' : 'collapsed'"
                                />
                            </button>
                        }
                    </td>
                }
                @for (header of tableData?.headers;
					let first = $first;
					let last = $last;
					let index = $index;
					track index) {
                    <!-- Normal row -->
                    <td
                        class="CeActionTable-row-item u-text-body-sm"
                        [ngClass]="{ 'flex-center': last, 'flex-start': !last }"
                    >
                        @if (first) {
                            <span class="CeActionTable-row-item--text-wrapper u-text-truncate">
                                <ng-container
                                    [ngTemplateOutlet]="cellContent"
                                    [ngTemplateOutletContext]="{
                                        content: row.content | getContentPipe: header,
                                        row: row,
                                        first: first,
                                    }"
                                ></ng-container>
                            </span>
                        } @else {
                            <ng-container
                                [ngTemplateOutlet]="cellContent"
                                [ngTemplateOutletContext]="{
                                    content: row.content | getContentPipe: header,
                                    row: row,
                                    first: first,
                                }"
                            ></ng-container>
                        }
                    </td>
                }

                <!-- Empty td for shadow-->
                @if (!lastColumnSticky()) {
                    <td class="shadow-indicator shadow-indicator--last" [attr.aria-hidden]="true"></td>
                }
            </tr>

            <!--  Children -->
            @if (row.children && !row.collapsed) {
                @for (child of row?.children; let last = $last; let index = $index; track index) {
                    <tr
                        class="CeActionTable-row"
                        [ngClass]="{
                            'CeActionTable-row--selected': child.selected && tableData?.isSelectable,
                            'CeActionTable-row--disabled': child?.disabled,
                        }"
                    >
                        <!-- Empty td for shadow-->
                        @if (!firstColumnSticky()) {
                            <td class="shadow-indicator shadow-indicator--first" [attr.aria-hidden]="true"></td>
                        }

                        <td class="CeActionTable-row-item--empty"></td>
                        @for (header of tableData?.headers;
							let first = $first;
							let last = $last;
							let index = $index;
							track index) {
                            <td
                                class="CeActionTable-row-item u-text-body-sm"
                                [ngClass]="{
                                    'flex-center': last,
                                    'flex-start': !last,
                                    ' CeActionTable-row-item--child-first': first,
                                }"
                                [attr.aria-label]="
                                    first ? 'Descendant of ' + (row.content | getContentPipe: header) : null
                                "
                            >
                                @if (first) {
                                    <span class="CeActionTable-row-item--text-wrapper u-text-truncate">
                                        <ng-container
                                            [ngTemplateOutlet]="cellContent"
                                            [ngTemplateOutletContext]="{
                                                content: child.content | getContentPipe: header,
                                                row: child,
                                                first: first,
                                                parent: row,
                                            }"
                                        ></ng-container>
                                    </span>
                                } @else {
                                    <ng-container
                                        [ngTemplateOutlet]="cellContent"
                                        [ngTemplateOutletContext]="{
                                            content: child.content | getContentPipe: header,
                                            row: child,
                                            first: first,
                                            parent: row,
                                        }"
                                    ></ng-container>
                                }
                            </td>
                        }

                        <!-- Empty td for shadow-->
                        @if (!lastColumnSticky()) {
                            <td class="shadow-indicator shadow-indicator--last" [attr.aria-hidden]="true"></td>
                        }
                    </tr>
                }
            }
        }

        @if (lastRowLoading()) {
            <tr>
                <td colSpan="100" class="CeActionTable-row-placeholder">
                    <ce-skeleton-loader class="u-spacing-xs-mh u-spacing-sm-mv u-size-lg-h" />
                </td>
            </tr>
        }

        @if (showResultsHaveLoaded()) {
            <tr>
                <td colSpan="100" class="CeActionTable-row-no-more-results">
                    <span class="body-sm-default u-color-text-secondary u-spacing-sm-mv u-spacing-sm-pa">
                        Nothing more to load
                    </span>
                </td>
            </tr>
        }

        @if (showLoadMoreButton()) {
            <tr>
                <td colSpan="100" class="CeActionTable-row-load-more u-size-md-h u-spacing-sm-pa">
                    <button type="button" (click)="onLoadMoreClick()" ce-button-small ce-button-type-quaternary>
                        Load more
                    </button>
                </td>
            </tr>
        }

        <ng-template #headersTemplate>
            <tr class="CeActionTable-header">
                <!-- Empty th for shadow-->
                @if (!firstColumnSticky()) {
                    <th class="shadow-indicator shadow-indicator--first" [attr.aria-hidden]="true"></th>
                }

                <!-- Empty th for nested tables-->
                @if (tableContainsSecondLevel) {
                    <th
                        class="CeActionTable-header-item CeActionTable-header-item--empty u-text-label-sm"
                        [id]="'empty-' + topLevelCheckboxId"
                    ></th>
                }
                @for (header of tableData?.headers;
					let index = $index;
					let last = $last;
					let first = $first;
					track index) {
                    @if (first && tableData?.isSelectable) {
                        <!-- For selectable tables -->
                        <th class="CeActionTable-header-item u-text-label-sm flex-start" [id]="header">
                            <ce-checkbox
                                [checked]="topLevelSelected"
                                (checkboxValueChanged)="onTopLevelSelect($event)"
                                [mixed]="topLevelMixed"
                                [readOnly]="tableData?.readOnly ?? false"
                                [id]="topLevelCheckboxId"
                                label=""
                                class="u-spacing-none-mb"
                            >
                                <ng-container
                                    [ngTemplateOutlet]="headerContent"
                                    [ngTemplateOutletContext]="{
                                        header: header,
                                    }"
                                />
                            </ce-checkbox>
                        </th>
                    } @else {
                        <!-- Normal th -->
                        <th
                            class="CeActionTable-header-item u-text-label-sm"
                            [id]="header"
                            [ngClass]="{ 'flex-center': last, 'flex-start': !last }"
                        >
                            <ng-container
                                [ngTemplateOutlet]="headerContent"
                                [ngTemplateOutletContext]="{
                                    header: header,
                                }"
                            />
                        </th>
                    }
                }

                <!-- Empty th for shadow-->
                @if (!lastColumnSticky()) {
                    <th class="shadow-indicator shadow-indicator--last" [attr.aria-hidden]="true"></th>
                }
            </tr>
        </ng-template>

        <ng-template #headerContent let-header="header">
            @if (header.text && header.infoButton && header.component) {
                <!-- Heading with a CeInfoButton component -->
                <span class="CeActionTable-header-with-action">
                    {{ header.text }}
                    <ce-info-button
                        [component]="header.component"
                        size="small"
                        contentPadding="sm"
                        [cePopoverWorksOnHover]="true"
                        popoverWidth="9xl"
                    />
                </span>
            } @else if (header.text && header.textAlignedRight && !header.width) {
                <!-- Heading aligned right-->
                <span class="flex flex-end">
                    {{ header.text }}
                </span>
            } @else if (header.text && header.textAlignedRight && header.width) {
                <!-- Heading aligned right with fixed width -->
                <span class="flex flex-end u-size-{{ header.width }}-w">
                    {{ header.text }}
                </span>
            } @else if (header.text && !header.textAlignedRight && header.width) {
                <!-- Heading with fixed width -->
                <span class="flex u-size-{{ header.width }}-w">
                    {{ header.text }}
                </span>
            } @else if (header.hidden !== undefined) {
                <!-- Hideable heading -->
                <span class="flex flex-between">
                    {{ header.text }}
                </span>
            } @else {
                <!-- Normal heading (string) -->
                {{ header }}
            }
        </ng-template>

        <ng-template #cellContent let-row="row" let-content="content" let-first="first" let-parent="parent">
            @if (first && tableData?.isSelectable && !row.hideCheckbox) {
                <div class="CeActionTable-selectable-content">
                    <ce-checkbox
                        [checked]="row.selected"
                        (checkboxValueChanged)="onItemSelect($event, row, parent)"
                        [readOnly]="tableData?.readOnly ?? false"
                        [id]="row.checkboxId"
                        label=""
                        class="u-spacing-none-mb"
                    >
                        @switch (getType(content)) {
                            @case ('Two row cell') {
                                <ng-container
                                    [ngTemplateOutlet]="twoCellContent"
                                    [ngTemplateOutletContext]="{ content: content }"
                                ></ng-container>
                            }
                            @default {
                                {{ content }}
                            }
                        }
                    </ce-checkbox>
                </div>
            } @else if (first && tableData?.isSelectable && row.hideCheckbox) {
                <div class="CeActionTable-selectable-content">
                    <span class="CeActionTable-checkbox-spacer" aria-hidden="true"></span>
                    <div>
                        @switch (getType(content)) {
                            @case ('Two row cell') {
                                <ng-container
                                    [ngTemplateOutlet]="twoCellContent"
                                    [ngTemplateOutletContext]="{ content: content }"
                                ></ng-container>
                            }
                            @default {
                                {{ content }}
                            }
                        }
                    </div>
                </div>
            } @else {
                @switch (getType(content)) {
                    @case ('Pill') {
                        <ng-container
                            [ngTemplateOutlet]="pillContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('PillArray') {
                        <ng-container
                            [ngTemplateOutlet]="pillArrayContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('StatusBox') {
                        <ng-container
                            [ngTemplateOutlet]="statusBoxContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('Action') {
                        <ng-container
                            [ngTemplateOutlet]="actionContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('Context menu') {
                        <ng-container
                            [ngTemplateOutlet]="contextMenuContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('External link') {
                        <ng-container
                            [ngTemplateOutlet]="linkContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('Router link') {
                        <ng-container
                            [ngTemplateOutlet]="routerLinkContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('Two row cell') {
                        <ng-container
                            [ngTemplateOutlet]="twoCellContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('undefined') {
                        <ng-container></ng-container>
                    }
                    @case ('Text aligned right') {
                        <ng-container
                            [ngTemplateOutlet]="textAlignRightContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('Dashed text with popover') {
                        <ng-container
                            [ngTemplateOutlet]="dashedTextWithPopover"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @case ('Placeholder') {
                        <ng-container
                            [ngTemplateOutlet]="placeholderContent"
                            [ngTemplateOutletContext]="{ content: content }"
                        ></ng-container>
                    }
                    @default {
                        {{ content }}
                    }
                }
            }

            <!-- Text aligned right link -->
            <ng-template #textAlignRightContent let-content="content">
                <span class="flex flex-end">
                    @if (content.placeholder) {
                        <span class="u-color-text-placeholder">{{ content.text }}</span>
                    } @else {
                        {{ content.text }}
                    }
                    @if (content.unit) {
                        <span class="u-color-text-secondary"> {{ content.unit }}</span>
                    }
                </span>
            </ng-template>

            <!-- External link -->
            <ng-template #linkContent let-content="content">
                @if (content.tooltipText) {
                    <a
                        ce-link-button
                        ce-link-button-type-secondary
                        ce-link-button-small
                        [href]="content.href"
                        target="_blank"
                        [ceTooltip]="content.tooltipText"
                    >
                        {{ content.text }}
                        <ce-icon svgIcon="new-tab" class="u-spacing-sm-ml"></ce-icon>
                    </a>
                } @else {
                    <a
                        ce-link-button
                        ce-link-button-type-secondary
                        ce-link-button-small
                        [href]="content.href"
                        target="_blank"
                    >
                        {{ content.text }}
                        <ce-icon svgIcon="new-tab" class="u-spacing-sm-ml"></ce-icon>
                    </a>
                }
            </ng-template>

            <!-- Router link -->
            <ng-template #routerLinkContent let-content="content">
                @if (content.tooltipText) {
                    <a
                        [routerLink]="content.routerLink"
                        ce-link-button
                        ce-link-button-type-secondary
                        ce-link-button-small
                        [ceTooltip]="content.tooltipText"
                    >
                        {{ content.text }}
                    </a>
                } @else {
                    <a
                        [routerLink]="content.routerLink"
                        ce-link-button
                        ce-link-button-type-secondary
                        ce-link-button-small
                    >
                        {{ content.text }}
                    </a>
                }
            </ng-template>

            <!-- Two cell content -->
            <ng-template #twoCellContent let-content="content">
                @if (content.pill) {
                    <div class="CeActionTable-row-item--two-row-cell flex">
                        <span class="u-text-truncate">{{ content.text }}</span>
                        <ce-pill
                            [state]="content?.pill.state ? content.pill.state : 'default'"
                            [icon]="content?.pill.icon ? content.pill.icon : undefined"
                            [attr.ce-pill-primary]="content?.pill.style === 'primary' ? '' : null"
                            [attr.ce-pill-secondary]="content?.pill.style === 'secondary' || !content?.pill.style ? '' : null"
                            [attr.ce-pill-tertiary]="content?.pill.style === 'tertiary' ? '' : null"
                            [attr.ce-pill-code]="content?.pill.style === 'code' ? '' : null"
                            class="u-spacing-sm-ml"
                        >{{ content.pill.text }}
                        </ce-pill>
                    </div>
                    <span class="u-color-text-secondary">{{ content.secondaryText }}</span>
                } @else {
                    <div class="CeActionTable-row-item--two-row-cell u-text-truncate">{{ content.text }}</div>
                    <span class="u-color-text-secondary">{{ content.secondaryText }}</span>
                }
            </ng-template>

            <!-- Pill -->
            <ng-template #pillContent let-content="content">
                <ce-pill
                    [state]="content?.state ? content.state : 'default'"
                    [icon]="content?.icon ? content.icon : undefined"
                    [attr.ce-pill-primary]="content?.style === 'primary' ? '' : null"
                    [attr.ce-pill-secondary]="content?.style === 'secondary' || !content?.style ? '' : null"
                    [attr.ce-pill-tertiary]="content?.style === 'tertiary' ? '' : null"
                    [attr.ce-pill-code]="content?.style === 'code' ? '' : null"
                >{{ content.text }}
                </ce-pill>
            </ng-template>

            <!-- Pill array -->
            <ng-template #pillArrayContent let-content="content">
                @let firstPill = content[0];
                @let secondPill = content[1];

                @if (secondPill) {
                    <div class="CeActionTable-pillArray"
                         [ce-popover-trigger-for]="pillArrayTemplate"
                         [cePopoverWorksOnHover]="true"
                         [ce-popover-position]="'above'">
                        <ce-pill
                            [state]="firstPill?.state ? firstPill.state : 'default'"
                            [icon]="firstPill?.icon ? firstPill.icon : undefined"
                            [attr.ce-pill-primary]="firstPill?.style === 'primary' ? '' : null"
                            [attr.ce-pill-secondary]="firstPill?.style === 'secondary' || !firstPill?.style ? '' : null"
                            [attr.ce-pill-tertiary]="firstPill?.style === 'tertiary' ? '' : null"
                            [attr.ce-pill-code]="firstPill?.style === 'code' ? '' : null"
                            class="u-spacing-xs-mr"
                        >{{ firstPill?.text }}
                        </ce-pill>

                        <ce-pill
                            [state]="secondPill?.state ? secondPill.state : 'default'"
                            [attr.ce-pill-primary]="secondPill?.style === 'primary' ? '' : null"
                            [attr.ce-pill-secondary]="secondPill?.style === 'secondary' || !secondPill?.style ? '' : null"
                            [attr.ce-pill-tertiary]="secondPill?.style === 'tertiary' ? '' : null"
                            [attr.ce-pill-code]="secondPill?.style === 'code' ? '' : null"
                            class="u-spacing-xs-mr"
                        >+{{ content.length - 1 }}
                        </ce-pill>

                        <ce-popover-overlay #pillArrayTemplate="cePopoverOverlay">
                            <ce-popover class="u-size-8xl-w u-spacing-sm-pa u-text-body-xs">
                                <ul class="u-spacing-none-ma u-spacing-md-pl">
                                    @for (pill of content; track pill.text) {
                                        <li>{{ pill.text }}</li>
                                    }
                                </ul>
                            </ce-popover>
                        </ce-popover-overlay>
                    </div>
                } @else {
                    <div class="flex flex-row">
                        <ce-pill
                            [state]="firstPill?.state ? firstPill.state : 'default'"
                            [icon]="firstPill?.icon ? firstPill.icon : undefined"
                            [attr.ce-pill-primary]="firstPill?.style === 'primary' ? '' : null"
                            [attr.ce-pill-secondary]="firstPill?.style === 'secondary' || !firstPill?.style ? '' : null"
                            [attr.ce-pill-tertiary]="firstPill?.style === 'tertiary' ? '' : null"
                            [attr.ce-pill-code]="firstPill?.style === 'code' ? '' : null"
                            class="u-spacing-xs-mr"
                        >{{ firstPill?.text }}
                        </ce-pill>
                    </div>
                }
            </ng-template>

            <!-- Status box -->
            <ng-template #statusBoxContent let-content="content">
                @for (statusBox of content; track statusBox) {
                    <ce-status-box
                        [state]="statusBox?.state ? statusBox.state : 'unknown'"
                        [icon]="statusBox?.icon ? statusBox.icon : undefined"
                        [label]="statusBox?.label"
                        [attr.type]="statusBox.type"
                        class="u-spacing-xs-mr"
                    >{{ statusBox.text }}
                    </ce-status-box>
                }
            </ng-template>

            <!-- Action -->
            <ng-template #actionContent let-content="content">
                <button
                    ce-link-button-small
                    ce-link-button-type-secondary
                    class="CeActionTable-action"
                    [disabled]="!!content?.inProgress"
                    [attr.aria-label]="content?.text ?? 'In progress'"
                    (click)="!content?.inProgress && content.action()"
                >
                    @if (!!content?.inProgress) {
                        <ce-spinning-loader />
                    } @else if (!!content.icon) {
                        <ce-icon [svgIcon]="content?.icon" [attr.aria-hidden]="true" />
                    } @else if (content.text) {
                        {{ content.text }}
                    }
                </button>
            </ng-template>

            <!-- Context menu -->
            <ng-template #contextMenuContent let-content="content">
                @let menuConfig = content?.contextMenu;
                @if (menuConfig) {
                    <button
                        ce-button-icon
                        ce-button-small
                        ce-button-type-quaternary
                        class="CeActionTable-context-menu-trigger"
                        [dsContextMenuTriggerFor]="actionMenu"
                        [dsContextMenuPosition]="'bottom-right'"
                        [dsContextMenuPositionOffsetX]="20"
                        aria-label="Open row actions"
                    >
                        <ce-icon svgIcon="more" />
                    </button>

                    <ds-context-menu #actionMenu>
                        <ds-list size="sm">
                            @for (item of menuConfig.items; track item) {
                                <ds-list-item
                                    [disabled]="item.disabled"
                                    (click)="!item.disabled && item.action()"
                                >
                                    @if (item.icon) {
                                        <ce-icon ds-list-item-prefix [svgIcon]="item.icon" ce-icon-sm />
                                    }
                                    <div ds-list-item-title>{{ item.label }}</div>
                                </ds-list-item>
                            }
                        </ds-list>
                    </ds-context-menu>
                }
            </ng-template>

            <!-- Dashed text with popover -->
            <ng-template #dashedTextWithPopover let-content="content">
                <span
                    class="CeActionTable-dashed-text u-text-underline-dashed"
                    [ce-popover-trigger-for]="dashedTextPopover"
                    [cePopoverWorksOnHover]="true"
                    [ce-popover-position]="content.popoverPosition ?? 'below-left'"
                >
                    {{ content.text }}
                </span>
                <ce-popover-overlay #dashedTextPopover="cePopoverOverlay">
                    <ce-popover class="u-text-body-sm u-size-7xl-w u-spacing-sm-pa">
                        @if (content.popoverTemplate) {
                            <ng-container *ngTemplateOutlet="content.popoverTemplate"></ng-container>
                        } @else if (content.popoverHtml) {
                            <span [innerHTML]="content.popoverHtml"></span>
                        }
                    </ce-popover>
                </ce-popover-overlay>
            </ng-template>

            <!-- Placeholder text -->
            <ng-template #placeholderContent let-content="content">
                <span class="u-color-text-placeholder">{{ content.text }}</span>
            </ng-template>
        </ng-template>
    </table>
</div>
<div class="CeActionTable-sticky-scroll" #stickyScroll>
    <div class="CeActionTable-scroll"></div>
</div>
